/*
Adapted from jQuery.Turbolinks ~ https://github.com/kossnocorp/jquery.turbolinks (MIT).

Turbo swaps the <body> without firing DOMContentLoaded, so $(document).ready callbacks would only
run on the first page load. This overrides $.fn.ready to re-fire them on every turbo:load — the
same shim the app ran under the fork, re-pointed at Turbo's events. See docs/turbo_migration.md.

Two differences from the classic version, both for parity:

  1. No native ready callback: Turbo fires turbo:load on the initial load too, so registering both
     would run every handler twice.
  2. Restoration visits are skipped: the fork fired page:restore, not page:load, and a restored
     body is already initialised (DataTables throws on re-init).
*/
(function () {
  var $ = window.jQuery
  var $document = $(document)

  $.turbo = {
    isReady: false,
    restoring: false,
    use: function (load, visit) {
      return $document
        .off(".turbo")
        .on(load + ".turbo", this.onLoad)
        .on(visit + ".turbo", this.onVisit)
    },
    addCallback: function (callback) {
      if ($.turbo.isReady) {
        callback($)
      }
      return $document.on("jqturbo:ready", function () {
        return callback($)
      })
    },
    onLoad: function () {
      if ($.turbo.restoring) {
        $.turbo.restoring = false
        return
      }
      $.turbo.isReady = true
      return $document.trigger("jqturbo:ready")
    },
    onVisit: function (event) {
      var nativeEvent = event.originalEvent || event
      var action = nativeEvent && nativeEvent.detail ? nativeEvent.detail.action : null

      if (action === "restore") {
        $.turbo.restoring = true
        return
      }

      $.turbo.restoring = false
      return ($.turbo.isReady = false)
    },
    register: function () {
      return ($.fn.ready = this.addCallback)
    },
  }

  $.turbo.register()
  $.turbo.use("turbo:load", "turbo:visit")
}).call(window)
